import { IAPIContext, IAPIContextValue, IAPIRawContext } from 'models/context/api-context';

export class SSOAPIContext {
    eventId: string;
    [key: string]: IAPIContextValue;

    constructor() {
        this.eventId = '';
    }

    static fromJsonToAPIContext(jsonString: string): IAPIContext {
        let parsedContext: IAPIRawContext;

        try {
            parsedContext = JSON.parse(jsonString) as IAPIRawContext;
        } catch (e) {
            throw new Error('Failed to parse provided JSON string: ' + jsonString);
        }

        const { 'event-id': eventId, ...inputProps } = parsedContext;

        //TODO: update convertKebabCasePropsToCamelCase to accept the full object and update the type of input to be IAPIRawContext and output to be IAPIContext
        const camelCaseProps = SSOAPIContext.convertKebabCasePropsToCamelCase(inputProps);

        const mappedContext: IAPIContext = {
            eventId: eventId ? String(eventId) : '',
            ...camelCaseProps
        };
        this.isSSOAPIContext(mappedContext);

        return mappedContext;
    }

    private static validate(obj: Record<string, unknown>, prop: keyof IAPIContext, type: string): void {
        if (!obj[prop] || typeof obj[prop] !== type) {
            const actualType = typeof obj[prop];
            throw new Error(`Missing or invalid property: '${prop}'. Expected type: ${type}, Actual type: ${actualType}`);
        }
    }

    private static isSSOAPIContext(obj: unknown): void {
        const objRecord = obj as Record<string, unknown>;
        this.validate(objRecord, 'eventId', 'string');
    }

    public static convertKebabCasePropsToCamelCase(inputProps: Record<string, unknown>): Record<string, unknown> {
        const camelCaseProps: Record<string, unknown> = {};
        for (const key in inputProps) {
            if (inputProps.hasOwnProperty(key)) {
                camelCaseProps[SSOAPIContext.convertKebabCaseToCamelCase(key)] = inputProps[key];
            }
        }
        return camelCaseProps;
    }

    static convertKebabCaseToCamelCase(str: string): string {
        return str.replace(/-([a-zA-Z])/g, (match, letter) => letter.toUpperCase());
    }    
}